export default "__VITE_ASSET__CFWuuzE5__"